import { useContext, type JSX } from 'react';
import { KodplanContext } from '../../../../../../../Components/KodplanManager/Context/KodplanContext';
import query from './EkonomiskAnalysCodePrivilegesQuery.gql';
import {
  EkonomiskAnalysCodePrivilegesQueryVariables as IVariables,
  EkonomiskAnalysCodePrivilegesQuery as IData,
} from './_QueryTypes/EkonomiskAnalysCodePrivilegesQuery';
import { ISelectedAnalysCodePrivilege } from '../../EkonomiskAnalysPage';
import useHandledQuery from '../../../../../../../Components/QueryComponents/HandledQuery/HandledQueryHook';

interface IProps {
  anvandsFor: string[];
  skip?: boolean;
  children: (codePrivileges: ISelectedAnalysCodePrivilege[]) => JSX.Element;
}

const EkonomiskAnalysCodePrivilegesQuery = (props: IProps) => {
  const { activeKodplan } = useContext(KodplanContext);
  const queryResult = useHandledQuery<IData, IVariables>(
    query,
    {
      variables: {
        kodplan_id: activeKodplan ? activeKodplan.id : '',
        anvands_for: props.anvandsFor,
      },
      skip: props.skip,
    },
    { loadingComponent: null }
  );

  if (props.skip) {
    return <>{props.children([])}</>;
  }

  if (!queryResult.data) {
    return queryResult.renderComponent;
  }

  const { data } = queryResult;

  const codePrivileges: ISelectedAnalysCodePrivilege[] =
    data.ekallakodbehorigheter
      ? data.ekallakodbehorigheter.map(x => {
          return {
            name: x.name,
            id: x.kodbeh_id,
          };
        })
      : [];
  return props.children(codePrivileges);
};

export default EkonomiskAnalysCodePrivilegesQuery;
